// -----------------------------------------------------------------------------
// A2P 10DLC SMS Consent — shared, canonical language
// -----------------------------------------------------------------------------
// Both consent checkboxes are independent, optional and unchecked by default.
// Providing a phone number NEVER implies SMS consent — each opt-in is tracked
// separately, stored with a timestamp, and forwarded to GHL as its own flag.
//
// The exact label text below is captured verbatim at submit time (via
// `sms_consent_language_marketing` / `sms_consent_language_transactional`)
// so we retain a compliant audit trail per submission.
//
// Identity phrasing — "Bounce City University (operated by Bounce City 321
// LLC)" — matches the relationship wording used across Privacy Policy, Terms
// & Conditions, and the A2P registration copy pack. It does NOT claim DBA
// status; if Bounce City University is later confirmed as a registered DBA
// or is re-registered under a different customer-facing sender identity, this
// file is the single place to update.
// -----------------------------------------------------------------------------

export const SMS_TRANSACTIONAL_LABEL =
  "I agree to receive non-marketing text messages from Bounce City University (operated by Bounce City 321 LLC) about my application, consultation, appointments, enrollment status, and service updates. Message frequency may vary. Message & data rates may apply. Reply STOP to opt out or HELP for help.";

export const SMS_MARKETING_LABEL =
  "I agree to receive marketing and promotional text messages from Bounce City University (operated by Bounce City 321 LLC) about enrollment opportunities, program updates, special offers, events, and promotions. Message frequency may vary. Message & data rates may apply. Consent is not a condition of purchase. Reply STOP to opt out or HELP for help.";

export const SMS_PHONE_DISCLOSURE =
  "Providing a mobile number does not enroll you in SMS. Text messages are only sent if you opt in below.";
